import { buildFilteredUrl } from "./buildFilteredUrl";

type Inputs = {
  selectElement: HTMLSelectElement;
};

// Navigates to the same report with the chosen organization applied (or cleared),
// preserving any other query params already on the URL. The param name comes from
// the element's `data-filter-param` so the same wiring can drive other filters.
export function initOrganizationFilter({ selectElement }: Inputs): void {
  selectElement.addEventListener("change", () => {
    const param = selectElement.dataset.filterParam ?? "organization_id";
    window.location.assign(buildFilteredUrl(window.location.href, param, selectElement.value));
  });
}
